import { useEffect, useRef, useState } from "react";
import { Link as RouterLink, useSearchParams } from "react-router-dom";
import { Stack, Heading, Text, Spinner, Link, Button, Input } from "@chakra-ui/react";
import { useVerifyEmailMutation } from "../hooks/useVerifyEmailMutation";
import { useResendVerificationMutation } from "../hooks/useResendVerificationMutation";

// Corrige o bug do VerifyAccount.js original: o token vem por QUERY STRING
// (?token=...), não pelo path — é assim que o backend (pkg/email/sender.go) monta o link.
export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const verifyMutation = useVerifyEmailMutation();
  const resendMutation = useResendVerificationMutation();
  const [email, setEmail] = useState("");
  const attempted = useRef(false);

  useEffect(() => {
    if (token && !attempted.current) {
      attempted.current = true;
      verifyMutation.mutate(token);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  if (!token) {
    return (
      <Stack spacing={3} textAlign="center">
        <Heading size="md">Link inválido</Heading>
        <Text color="app-muted-fg" fontSize="sm">
          Este link de verificação está incompleto. Solicite um novo e-mail de verificação na tela de login.
        </Text>
        <Link as={RouterLink} to="/auth/login" color="accent-text" fontSize="sm">
          Voltar para o login
        </Link>
      </Stack>
    );
  }

  if (verifyMutation.isPending) {
    return (
      <Stack spacing={3} align="center" textAlign="center">
        <Spinner color="primary" />
        <Text color="app-muted-fg" fontSize="sm">
          Verificando seu e-mail...
        </Text>
      </Stack>
    );
  }

  if (verifyMutation.isSuccess) {
    return (
      <Stack spacing={3} textAlign="center">
        <Heading size="md">E-mail verificado!</Heading>
        <Text color="app-muted-fg" fontSize="sm">
          Sua conta está pronta. Faça login para continuar.
        </Text>
        <Button as={RouterLink} to="/auth/login">
          Ir para o login
        </Button>
      </Stack>
    );
  }

  return (
    <Stack spacing={4} textAlign="center">
      <Heading size="md">Não foi possível verificar</Heading>
      <Text color="app-muted-fg" fontSize="sm">
        O link pode ter expirado. Informe seu e-mail para receber um novo link de verificação.
      </Text>
      <Stack spacing={2}>
        <Input
          type="email"
          placeholder="seu@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Button
          isDisabled={!email}
          isLoading={resendMutation.isPending}
          onClick={() => resendMutation.mutate(email)}
        >
          {resendMutation.isSuccess ? "Link reenviado" : "Reenviar link de verificação"}
        </Button>
      </Stack>
      <Link as={RouterLink} to="/auth/login" color="accent-text" fontSize="sm">
        Voltar para o login
      </Link>
    </Stack>
  );
}
